import { LoadingButton } from "@mui/lab";
import { Box, FormControl, Grid, InputLabel, TextField } from "@mui/material";
import axios, { AxiosInstance } from "axios";
import React, { FC, Fragment, useEffect, useState } from "react";
import Cookies from "universal-cookie";
import CheckAttr from "../../../utils/CheckAttr";
import { SecondNiveau } from "../../content/parametrage/Article/Article";
import { useStyles } from "../styles";
import SaveIcon from "@mui/icons-material/Save";
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { loggoutUser } from "../../../redux/actions/logginUser";


interface InputValidation {
  dateDebut: boolean;
  TarifHeure: boolean;
  TarifActe: boolean;
  coutA: boolean;
  dateCout: boolean;
}

const resetInpuValidation: InputValidation = {
  dateDebut: false,
  TarifActe: false,
  TarifHeure: false,
  coutA: false,
  dateCout: false,
};


interface UpdateCoutFormProps {
  articleSecond: SecondNiveau;
  onClose: () => void;
  openModal: boolean;
  reloadList: () => void;
}

const DuplicateCoutsByArticle: FC<UpdateCoutFormProps> = ({
  articleSecond,
  onClose,
  openModal,
  reloadList,
}) => {
  const classes = useStyles();
  const [coutToUpdate, setCoutToUpdate] = useState<string>(
    articleSecond?.coutactivite ? articleSecond?.coutactivite : ""
  );
  const [dateDebut, setDateDebut] = useState<Date | undefined>(
    articleSecond?.couts_date_debut
  );
  const [parentDateDebut, setParentDateDebut] = useState<Date | undefined>();
  const cookies = new Cookies();
  const token: string = cookies.get("jwt");
  const [isClickSave, setIsClickSave] = useState<boolean>(false);
  const [errorInput, setErrorInput] =
    useState<InputValidation>(resetInpuValidation);

  const urlBaseApi = process.env.REACT_APP_BASE_API_URL as string;
  const http: AxiosInstance = axios.create({
    baseURL: urlBaseApi,
    // timeout: 1000,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  
  const navigate = useNavigate();
  const dispatch = useDispatch();


 // Add global response interceptor
  http.interceptors.response.use(
      (response) => {
      // Modify response data here, if needed
      return response;
      },
      (error) => {
          console.log(error.message);
          if(error.message ==="Request failed with status code 401"){
              // Remove the redux store
              dispatch(loggoutUser());

              // Remove token in navigator cookies
              cookies.remove('jwt', { path: '/' });

              navigate("/sign-in");
          }
          return Promise.reject(error);
      }
  );


  const isValidate = (): boolean => {
    if (!CheckAttr(dateDebut) || !CheckAttr(coutToUpdate)){
      if (!CheckAttr(coutToUpdate)) {
        setErrorInput((prev: InputValidation) => ({
          ...prev,
          coutA: true,
        }));
      }

      if (!CheckAttr(dateDebut)) {
        setErrorInput((prev: InputValidation) => ({
          ...prev,
          dateCout: true,
        }));
      }
      return false;
    }
    return true;
  }

  useEffect(() => {
    if (openModal) {
      http
        .get(
          `article/get-date-debut-parent-for/Cout/${articleSecond?.couts_id}`
        )
        .then((res) => {
          setParentDateDebut(res.data);
        }).catch(error => {
          console.log(error);
      });
    }
  }, []);

  const handleDuplicate = () => {
    setIsClickSave(true);
    const data = {
      id: articleSecond?.couts_id,
      date_debut: dateDebut,
      coutactivite: coutToUpdate,
    };
    http
      .post("cout/duplicate", data)
      .then(() => {
        onClose();
        reloadList();
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setIsClickSave(false);
      });
  };

  const handleSave = () => {
    if (isValidate()) {
      handleDuplicate();
    }
  };
  return (
    <Fragment>
      <Grid container spacing={2} columns={{ xs: 6, sm: 12, md: 4 }}>
        <Grid item xs={6} sm={6} md={2}>
          <FormControl
            variant="outlined"
            className={classes.formControl}
            sx={{ marginLeft: 1, marginTop: 1 }}
          >
            <TextField
              name="libelleClient"
              label="Pays"
              color="warning"
              fullWidth
              // error={errorInput.libelle}
              disabled
              autoComplete="off"
              value={articleSecond?.pays_libelle}
              InputLabelProps={{
                shrink: CheckAttr(articleSecond?.libelle),
              }}
            />
          </FormControl>
          <FormControl
            variant="outlined"
            className={classes.formControl}
            sx={{ marginLeft: 1, marginTop: 1 }}
          >
            <TextField
              name="libelleClient"
              label="Bu"
              color="warning"
              fullWidth
              // error={errorInput.libelle}
              disabled
              autoComplete="off"
              value={articleSecond?.bu_libelle}
              InputLabelProps={{
                shrink: CheckAttr(articleSecond?.libelle),
              }}
            />
          </FormControl>
          <FormControl
            variant="outlined"
            className={classes.formControl}
            sx={{ marginLeft: 1, marginTop: 1 }}
          >
            <TextField
              name="coutactivite"
              label="Coût activité"
              color="warning"
              fullWidth
              autoComplete="off"
              type="number"
              placeholder="Ex: 2.02"
              inputProps={{
                step: 0.01,
                lang: "en-US",
              }}
              error={errorInput.coutA}
              value={coutToUpdate}
              onChange={(e) => setCoutToUpdate(e.target.value)}
              InputLabelProps={{
                shrink: CheckAttr(coutToUpdate),
              }}
            />
          </FormControl>
        </Grid>

        <Grid item xs={6} sm={6} md={2}>
          <FormControl
            variant="outlined"
            className={classes.formControl}
            sx={{ marginLeft: 1, marginTop: 1 }}
          >
            <TextField
              name="libelleClient"
              label="Article"
              color="warning"
              fullWidth
              // error={errorInput.libelle}
              disabled
              autoComplete="off"
              value={articleSecond?.libelle}
              InputLabelProps={{
                shrink: CheckAttr(articleSecond?.libelle),
              }}
            />
          </FormControl>
          <FormControl
            variant="outlined"
            className={classes.formControl}
            sx={{ marginLeft: 1, marginTop: 1 }}
          >
            <TextField
              name="libelleClient"
              label="Code Article"
              color="warning"
              fullWidth
              // error={errorInput.libelle}
              disabled
              autoComplete="off"
              value={articleSecond?.code_article_libelle}
              InputLabelProps={{
                shrink: CheckAttr(articleSecond?.libelle),
              }}
            />
          </FormControl>
          <FormControl
            variant="outlined"
            className={classes.formControl}
            sx={{ marginTop: 1 }}
          >
            <TextField
              name="date_debut"
              label="Date debut"
              type="date"
              color="warning"
              fullWidth
              error={errorInput.dateCout}
              value={dateDebut}
              inputProps={{
                // min: minDate()
                min: parentDateDebut,
              }}
              onChange={(e: any) => setDateDebut(e.target.value)}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </FormControl>
        </Grid>
      </Grid>
      <Box display="flex" justifyContent="center" mt={5}>
        <LoadingButton
          onClick={() => handleSave()}
          endIcon={<SaveIcon />}
          loading={isClickSave}
          loadingPosition="end"
          sx={{ textTransform: "none" }}
          variant="contained"
          color="warning"
        >
          Enregistrer
        </LoadingButton>
      </Box>
    </Fragment>
  );
};

export default DuplicateCoutsByArticle;
